var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":_vm.toolbarcolor,"dense":"","flat":""}},[[_vm._t("content")],[_vm._t("menu")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }